import React from 'react'
import icon__toggle__arrow from '../../../asset/icon/icondown.svg'
import icon__green__vector from '../../../asset/icon/green-vector.svg'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
function ToggleIcon({ toggleCards, toggleStatus = false, onToggle, css, toggleFront, storkeNoneColor, role }) {
    const toggleStyle = toggleStatus ? `${storkeNoneColor === 'nonecolor' ? 'stroke-[#526F65]' : 'stroke-[#FFFFFF]'} w-5 stroke-[3px] transition-all duration-500 ease-in-out rotate-[180deg]` : `${storkeNoneColor === 'nonecolor' ? 'stroke-[#526F65]' : 'stroke-[#FFFFFF]'} stroke-[3px] w-5 transition-all duration-500 ease-in-out rotate-[0deg]`
    const toggleStyleNew = toggleStatus ? 'transition-all duration-500 ease-in-out rotate-[90deg]' : 'transition-all duration-500 ease-in-out rotate-[0deg]'
    const toggleStyleAdmin = toggleStatus ? `${storkeNoneColor === 'nonecolor' ? 'stroke-[#526F65]' : 'stroke-[#FFFFFF]'} w-5 stroke-[3px] transition-all duration-500 ease-in-out rotate-[180deg]` : `${storkeNoneColor === 'nonecolor' ? 'stroke-[#526F65]' : 'stroke-[#FFFFFF]'} stroke-[3px] w-5 transition-all duration-500 ease-in-out rotate-[0deg]`

    return (
        <>
            {
                toggleCards ?
                    <>
                        <div onClick={() => {
                            onToggle()
                        }} className={css}>
                            {/* <img className={toggleStyle} src={icon__toggle__arrow} alt=''/> */}
                            <ChevronDownIcon className={ role === 'admin' ? toggleStyleAdmin : toggleStyle} />
                        </div>
                    </> : null
            }
            {
                toggleFront ?
                    <>
                        <div onClick={() => {
                            onToggle()
                        }} className={css}>
                            <img className={toggleStyleNew} src={icon__green__vector} alt=''/>
                        </div>
                    </> : null
            }
        </>
    )
}

export default ToggleIcon